import { Component, Input } from '@angular/core';
import { Lead } from '../lead.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadsService } from 'src/app/service/lead.service';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-status-modal',
  templateUrl: './update-status-modal.component.html',
  styleUrls: ['./update-status-modal.component.css']
})
export class UpdateStatusModalComponent {
  lead: any;
  updateStatus = false;
  prevStatus:any;
  selectedStatus: any;
  @Input() isQuery: boolean = false;
  uid:any;

  constructor(
    public activeModal: NgbActiveModal, private httpService: HttpService, private toastr:ToastrService
  ) { }


  ngOnInit() {
    this.prevStatus = this.lead.status
    this.uid = localStorage.getItem('profuid');
    // this.httpService.sendGetRequest(URLUtils.leadslawyers(this.uid)).subscribe((response: any) => {
    //   this.lead = response.data
    // });
    //console.log('getLeadData',this.lead)

    this.lead.status = this.lead.status

    if(this.lead.status == 'new' || this.lead.status == 'active'){
      this.lead.status = 'New'
    }
    // if(this.lead.status == 'active'){
    //   this.lead.status = 'Active'
    // }
  }

  selectStatus(status: any) {
    this.lead.status = status;
  }
  
  confirmLog(){
    this.updateStatus = true;
  }

  cancelLog(){
    this.updateStatus = false;
  }
  
  updateLog() {
    let status = {"account_status": this.lead.status}
    this.uid = localStorage.getItem('profuid');
    let id =  this.lead.id;

    // Choose the appropriate API endpoint based on whether this is a query or lead
    const endpoint = this.isQuery
      ? URLUtils.updateQueryStatus(id,this.uid)
      : URLUtils.updateStatus(id);

      //console.log('isQuery',this.isQuery)
    // Use different HTTP methods based on whether this is a query or lead
    if (this.isQuery) {
      // For queries, use sendRePatchRequest
      this.httpService.sendRePatchRequest(endpoint,status).subscribe((res: any) => {
        this.toastr.success('Status updated successfully');
        this.activeModal.close(res); 
      });
    } else {
      // For leads, use sendPatchRequest
      this.httpService.sendPatchRequest(endpoint,status).subscribe((res: any) => {
        this.toastr.success('Status updated successfully');
        this.activeModal.close(res); 
      });
    }

    // this.httpService.sendRePatchRequest(URLUtils.updateQueryStatus(id, uid),status).subscribe((res: any) => {
    //   this.toastr.success('Status updated successfully');
    //   this.activeModal.close(res); 
    // });
  }


  closeModal(){
    this.activeModal.close();
  }
}
